import { Link } from 'react-router-dom';
import { useAirlineLanding } from '../AirlineContext';

export default function SwAirlines() {
  const { airlines } = useAirlineLanding();

  return (
    <section className="swp-airlines">
      <div className="swp-shell">
        <p className="swp-eyebrow">Compare carriers</p>
        <h2>More airlines worth checking</h2>
        <p className="swp-airlines__intro">Review similar options across leading U.S. and leisure carriers</p>

        <div className="swp-airlines__grid">
          {airlines.map((airline) => {
            const body = (
              <>
                <span className="swp-airline__code">{airline.code}</span>
                <strong>{airline.name}</strong>
                <span className="swp-airline__note">{airline.note ?? 'Compare fares'}</span>
              </>
            );
            return airline.href ? (
              <Link className="swp-airline" key={airline.name} to={airline.href}>
                {body}
              </Link>
            ) : (
              <div className="swp-airline" key={airline.name}>
                {body}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
